/**
 * Third-party brand marks — another company's colour, not ours.
 *
 * A LinkedIn "in" or the Stripe wordmark keeps the brand's own colour: a Tonnie
 * tone would misrepresent the mark. They live here, the one web file the raw-hex
 * lint rule allows for this purpose
 * (`WEB_HEX_COLOR_ALLOWLIST` in config/lint/base.eslint.config.mjs), as whole
 * class names so Tailwind generates each of them.
 *
 * A brand colour used as TEXT on the page turns white in the dark theme, where
 * the brand's blue or purple reads under 4.5:1 on the dark surfaces.
 */
export const THIRD_PARTY_BRAND_CLASSES = {
  /** LinkedIn's mark or link text on a surface. */
  linkedinText: 'text-[#0A66C2] dark:text-white',
  /** LinkedIn's tint behind its mark. */
  linkedinTint: 'bg-[#0A66C2]/10',
  /** The Stripe wordmark as text. */
  stripeText: 'text-[#635BFF] dark:text-white',
  /** A card that carries a Stripe action: the brand's line and a faint wash. */
  stripeCard: 'border-[#635BFF]/20 bg-linear-to-r from-[#635BFF]/5 to-transparent',
  /** A button that hands off to Stripe. */
  stripeButton: 'bg-[#635BFF] hover:bg-[#635BFF]/90 text-white',
} as const;
